module.exports = __webpack_public_path__ + "img/fluids.459e4b5d.png";